import * as React from 'react'
import MUIDialog from '@mui/material/Dialog'

const Dialog = (props) => <MUIDialog {...props} />

export default Dialog
